import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../../components/Logo';

const TermsOfService: React.FC = () => {
  return (
    <div className="min-vh-100 bg-light">
      {/* Navigation */}
      <nav className="navbar navbar-expand-lg navbar-light bg-white border-bottom">
        <div className="container">
          <Link className="navbar-brand d-flex align-items-center" to="/">
            <Logo size="sm" className="me-2" />
            <span className="fw-bold">Dream Digi</span>
          </Link>
          
          <div className="navbar-nav ms-auto">
            <Link className="nav-link" to="/login">Login</Link>
            <Link className="nav-link btn btn-primary ms-2" to="/register">Get Started</Link>
          </div>
        </div>
      </nav>

      {/* Content */}
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="card border-0 shadow-sm">
              <div className="card-body p-5">
                <div className="text-center mb-5">
                  <Logo size="lg" className="mb-3" />
                  <h1 className="h2 fw-bold">Terms of Service</h1>
                  <p className="text-muted">Last updated: August 10, 2025</p>
                </div>

                <div className="legal-content">
                  <section className="mb-4">
                    <h2 className="h4 fw-bold mb-3">1. Acceptance of Terms</h2>
                    <p>
                      By accessing and using Dream Digi Page Optimization with AI ("Service"), you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.
                    </p>
                  </section>

                  <section className="mb-4">
                    <h2 className="h4 fw-bold mb-3">2. Description of Service</h2>
                    <p>
                      Dream Digi provides AI-powered website optimization services including but not limited to:
                    </p>
                    <ul>
                      <li>SEO (Search Engine Optimization) analysis and recommendations</li>
                      <li>GEO (Generative Engine Optimization) content optimization</li>
                      <li>Page speed optimization and performance analysis</li>
                      <li>Competitor analysis and market insights</li>
                      <li>Real-time analytics and reporting</li>
                      <li>AI-powered content recommendations</li>
                    </ul>
                  </section>

                  <section className="mb-4">
                    <h2 className="h4 fw-bold mb-3">3. User Accounts</h2>
                    <p>
                      To access certain features of the Service, you must create an account. You are responsible for:
                    </p>
                    <ul>
                      <li>Maintaining the confidentiality of your account credentials</li>
                      <li>All activities that occur under your account</li>
                      <li>Providing accurate and complete information</li>
                      <li>Notifying us immediately of any unauthorized use</li>
                    </ul>
                  </section>

                  <section className="mb-4">
                    <h2 className="h4 fw-bold mb-3">4. Subscription and Payment</h2>
                    <p>
                      Our Service operates on a subscription model with the following terms:
                    </p>
                    <ul>
                      <li>Free tier: 100 pages per month</li>
                      <li>Premium plans available for additional usage</li>
                      <li>Payments processed through secure payment gateways</li>
                      <li>Subscriptions auto-renew unless cancelled</li>
                      <li>Refunds subject to our refund policy</li>
                    </ul>
                  </section>

                  <section className="mb-4">
                    <h2 className="h4 fw-bold mb-3">5. Acceptable Use</h2>
                    <p>You agree not to use the Service to:</p>
                    <ul>
                      <li>Violate any applicable laws or regulations</li>
                      <li>Infringe on intellectual property rights</li>
                      <li>Transmit harmful, offensive, or inappropriate content</li>
                      <li>Attempt to gain unauthorized access to our systems</li>
                      <li>Interfere with the Service's operation</li>
                      <li>Use the Service for spam or malicious activities</li>
                    </ul>
                  </section>

                  <section className="mb-4">
                    <h2 className="h4 fw-bold mb-3">6. Data and Privacy</h2>
                    <p>
                      Your privacy is important to us. Our collection and use of personal information is governed by our Privacy Policy, which is incorporated into these Terms by reference.
                    </p>
                  </section>

                  <section className="mb-4">
                    <h2 className="h4 fw-bold mb-3">7. Intellectual Property</h2>
                    <p>
                      The Service and its original content, features, and functionality are owned by Dream Digi and are protected by international copyright, trademark, patent, trade secret, and other intellectual property laws.
                    </p>
                  </section>

                  <section className="mb-4">
                    <h2 className="h4 fw-bold mb-3">8. Limitation of Liability</h2>
                    <p>
                      In no event shall Dream Digi, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential, or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses.
                    </p>
                  </section>

                  <section className="mb-4">
                    <h2 className="h4 fw-bold mb-3">9. Termination</h2>
                    <p>
                      We may terminate or suspend your account and bar access to the Service immediately, without prior notice or liability, under our sole discretion, for any reason whatsoever and without limitation, including but not limited to a breach of the Terms.
                    </p>
                  </section>

                  <section className="mb-4">
                    <h2 className="h4 fw-bold mb-3">10. Changes to Terms</h2>
                    <p>
                      We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material, we will provide at least 30 days notice prior to any new terms taking effect.
                    </p>
                  </section>

                  <section className="mb-4">
                    <h2 className="h4 fw-bold mb-3">11. Contact Information</h2>
                    <p>
                      If you have any questions about these Terms of Service, please contact us at:
                    </p>
                    <ul>
                      <li>Email: legal@dream-digi.com</li>
                      <li>Website: ai.dream-digi.com</li>
                      <li>Address: [Your Business Address]</li>
                    </ul>
                  </section>
                </div>

                <div className="text-center mt-5">
                  <Link to="/register" className="btn btn-primary me-3">
                    Get Started
                  </Link>
                  <Link to="/" className="btn btn-outline-secondary">
                    Back to Home
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
